const datePickerLocale = {
  selectDate: "Select Date",
  now: "Now",
  clear: "Clear",
  selectDateRange: "Select Date Range",
  startTime: "Start Time",
  endTime: "End Time"
};
export {
  datePickerLocale
};
//# sourceMappingURL=en_US.js.map
